import { axiosInstance } from "@src/api/axiosConfig";
import { nestPath } from "../landRegister/axoisPath";
import { useMutation, useQuery, useInfiniteQuery } from "react-query";

const userPath = {
    confirmMatch: `${nestPath}/match/user/request/confirm`, // 매칭 확정
    completeMatch: (matchRequestNo: number) => `${nestPath}/match/user/complete/${matchRequestNo}`, // 매칭 완료
    denyCompleteMatchRequest: (matchNo: number) => `${nestPath}/match/user/deny/complete/${matchNo}`, // 완료 요청 거절
};

const takerPath = {
    cancelMatch: (matchRequestNo: number) => `${nestPath}/match/taker/request/${matchRequestNo}/cancel`, // 매칭 취소
    completeMatchRequest: (matchRequestNo: number) => `${nestPath}/match/taker/request/${matchRequestNo}/match/complete`, // 매칭 완료 요청
};

const confirmMatch = async (body: ConfirmMatchBody) => {
    const response = await axiosInstance.put<ConfirmMatchBody>(userPath.confirmMatch, body);
    return response.data;
};

type ConfirmMatchBody = {
    matchRequestNo: number;
    isAccept: boolean;
};

export const useConfirmMatch = () => {
    return useMutation({
        mutationFn: confirmMatch,
    });
};

const cancelMatch = async (matchRequestNo: number) => {
    const response = await axiosInstance.put(takerPath.cancelMatch(matchRequestNo));
    return response.data;
};

export const useCancelMatch = () => {
    return useMutation({
        mutationFn: cancelMatch,
    });
};

const takerCompleteMatch = async (matchRequestNo: number) => {
    const response = await axiosInstance.put(takerPath.completeMatchRequest(matchRequestNo));
    return response.data;
};

export const useTakerCompleteMatch = () => {
    return useMutation({
        mutationFn: takerCompleteMatch,
    });
};

const userCompleteMatch = async (matchNo: number) => {
    const response = await axiosInstance.put(userPath.completeMatch(matchNo));
    return response.data;
};

export const useUserCompleteMatch = () => {
    return useMutation({
        mutationFn: userCompleteMatch,
    });
};

// ------------------------------------------------------------

const checkItemStatus = async (itemId: string) => {
    const response = await axiosInstance.post<{ status: string }>(`${nestPath}/items/${itemId}/status`);
    return response.data;
};

export const useCheckItemStatus = () => {
    return useMutation({
        mutationFn: checkItemStatus,
    });
};

// [의뢰인] 완료 요청 거절하기
const denyCompleteMatchRequest = async (matchNo: number) => {
    const response = await axiosInstance.put(userPath.denyCompleteMatchRequest(matchNo));
    return response.data;
};

export const useDenyCompleteMatchOnRequest = () => {
    return useMutation({
        mutationFn: denyCompleteMatchRequest,
    });
};
